module.exports = __webpack_public_path__ + "img/profile-no_login.f4e5dee0.png";